import { Injectable } from "@angular/core";
import { MetaModel, WidgetModel } from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";
import { EmailTemplateModel } from "common/models/page-models/Email-Template/email-template-data-model";
import { EmailTemplateMetaModel } from "common/models/page-models/Email-Template/email-template-form-model";
import { EmailTemplateFormDataService } from "common/services/data-services/admin/email-template/email-template-form-data.service";



@Injectable({
    providedIn: 'root'
})
export class EmailTemplateFormWidgetService extends FormWidgetService<EmailTemplateModel> {
    constructor(protected ds: EmailTemplateFormDataService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new EmailTemplateMetaModel();
        return meta.getMetaModel();
    }
    
    override prepareMetaModel(dataModel:EmailTemplateModel, metaModel: EmailTemplateMetaModel, routeData: WidgetModel): Promise<EmailTemplateMetaModel> {
        return new Promise<EmailTemplateMetaModel>((resolve, reject) => {
            metaModel.pageTitle = dataModel.id !== 0 ?  "Edit Template" : "Add Template";
            resolve(metaModel);
          })
    }
}
